import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SharedModule } from '../_shared/shared.module';
import { NavigationModule } from '../navigation/navigation.module';
import { AlertsModule } from '../shared/modules/alerts/alerts.module';
import { ManageSavedSearchesComponent } from './manage-saved-searches/manage-saved-searches.component';
import { SavedSearchesRoutingModule } from './saved-searches-routing.module';
import { SavedSearchesComponent } from './saved-searches.component';

@NgModule({
  declarations: [ManageSavedSearchesComponent, SavedSearchesComponent],
  imports: [
    AlertsModule,
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    NavigationModule,
    SavedSearchesRoutingModule,
    SharedModule,
  ],
  exports: [ManageSavedSearchesComponent],
  entryComponents: [],
})
export class SavedSearchesModule {}
